import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-selfie-view-modal',
  templateUrl: './selfie-view-modal.component.html',
  styleUrls: ['./selfie-view-modal.component.scss']
})
export class SelfieViewModalComponent {
  @Input() selfieImageBase64: string;
  @Input() dateTime: string; 

  constructor(public activeModal: NgbActiveModal) {}

  close(): void {
    this.activeModal.close();
  }
}

